import { useEffect, useState } from "react"
import { inputDestinations, inputOneUserMap, inputUserListMap, inputUserMap } from "../../components/activityRegister/utils"
import { formatUserMapFilter, validateItemsMain } from "../constants"
import { useFilter } from "../../../../../../hooks/filter"
import { Item } from "../../../../../../utils/types/generals"

export const useUserFilter = ({ items = {} }: { items?: Record<string, Item[]>; }) => {
    const [input, setInput] = useState(inputUserMap)
    const filter = useFilter({
        formatFilter: formatUserMapFilter, externalValidation: (payload) => {
            const { localeBody, depatmentList } = validateItemsMain({ ...payload, departmentItem: items?.department })
            if (payload.name == 'area') {
                setInput(prev => ({
                    ...prev, department: { ...prev.department, items: depatmentList || [] },
                }))
            }
            return localeBody
        },
    })
    useEffect(() => {
        setInput(prev => ({
            ...prev,
            area: { ...prev.area, items: items?.area || [] },
            stores: { ...prev.stores, items: items?.stores || [] },
            role: { ...prev.role, items: items?.role || [] },
            division: { ...prev.division, items: items?.division || [] },
            userType: { ...prev.userType, items: items?.userType || [] },
            status: { ...prev.status, items: items?.status || [] },
            user: { ...prev.user, items: items?.user || [] },
        }))
    }, [items?.area, items?.stores, items?.role, items?.division, items?.userType, items?.user])
    return { input, filter }
}

export const useOneUserFilter = ({ items = {} }: { items?: Record<string, Item[]> }) => {
    const [input, setInput] = useState(inputOneUserMap)
    const filter = useFilter({
        formatFilter: formatUserMapFilter, externalValidation: (payload) => {
            const { localeBody, depatmentList } = validateItemsMain({ ...payload, departmentItem: items?.department })
            if (payload.name == 'area') {
                setInput(prev => ({
                    ...prev, department: { ...prev.department, items: depatmentList || [] },
                }))
            }
            return localeBody
        }
    })
    useEffect(() => {
        setInput(prev => ({
            ...prev,
            area: { ...prev.area, items: items?.area || [] },
            stores: { ...prev.stores, items: items?.stores || [] },
            status: { ...prev.status, items: items?.status || [] },
            year: { ...prev.year, items: items?.year || [] },
            month: { ...prev.month, items: items?.month || [] },
        }))
    }, [items?.area, items?.stores, items?.status])
    return { input, filter }
}
export const useListUserFilter = ({ items = {} }: { items?: Record<string, Item[]> }) => {
    const [input, setInput] = useState(inputUserListMap)
    const filter = useFilter({
        formatFilter: formatUserMapFilter, externalValidation: (payload) => {
            const { localeBody, depatmentList } = validateItemsMain({ ...payload, departmentItem: items?.department })
            if (payload.name == 'area') {
                setInput(prev => ({
                    ...prev, department: { ...prev.department, items: depatmentList || [] },
                }))
            }
            return localeBody
        }
    })
    useEffect(() => {
        setInput(prev => ({
            ...prev,
            area: { ...prev.area, items: items?.area || [] },
            status: { ...prev.status, items: items?.status || [] },
            stores: { ...prev.stores, items: items?.stores || [] },
            user: { ...prev.user, items: items?.user || [] },
        }))
    }, [items?.area, items?.status, items?.stores, items?.user])
    return { input, filter }
}

export const useDestinationsFilter = ({ items = {} }: { items?: Record<string, Item[]> }) => {
    const [input, setInput] = useState(inputDestinations)
    const filter = useFilter({ formatFilter: {from:'start_date',to:'end_date',user:'users_ids',role:'role_ids'} })
    useEffect(() => {
        setInput(prev => ({
            ...prev,
            role: { ...prev.role, items: items?.role || [] },
            user: { ...prev.user, items: items?.user || [] },
        }))
    }, [items?.role, items?.user])
    return { input, filter }
}